
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import WartelisteDatatable from '@/components/Impfverwaltung/Warteliste/WartelisteDatatable.vue';
    import WartelisteItem from '@/types/Warteliste';
    import { confirmSwal } from '@/helper/swals';
    import { SweetAlertResult } from 'sweetalert2';
    import Patient from '@/types/Patient';
    import { LoadWarteListePayload } from '@/store/warteliste';
    import _ from 'lodash';

    @Component({
        components: {
            WartelisteDatatable,
        },
        computed: {
            ...mapState('warteliste', ['warteliste', 'loaders']),
            ...mapState('authentication', ['status']),
            ...mapGetters('authentication', ['isAllowed']),
            ...mapState('patient', ['patientData']),
        },
        methods: {
            ...mapActions('warteliste', ['loadWarteliste', 'finishWarteliste', 'deleteWarteliste', 'updateWartelisteItems']),
            ...mapActions('patient', ['loadPatient', 'closePatient']),
            ...mapMutations('patient', ['setZahlendePatienten', 'setDialogRechnung']),
        },
    })
    export default class Warteliste extends Vue {
        @Prop({ default: () => true }) show!: boolean;

        public patientData!: Patient | null;
        public loadPatient!: (payload: { patnr: number }) => Promise<void>;
        public closePatient!: () => void;
        public loadWarteliste!: (payload?: LoadWarteListePayload) => void;
        public finishWarteliste!: (payload: { warteliste: number[] }) => void;
        public deleteWarteliste!: (payload: { warteliste: number[] }) => void;
        public updateWartelisteItems!: (payload: { wartelisteitems: Warteliste[] | null, einblenden: boolean }) => void;
        public setZahlendePatienten!: (patienten: WartelisteItem[]) => void;
        public setDialogRechnung!: (visible: boolean) => void;
        public warteliste: any;

        public selected: WartelisteItem[] = [];
        public openingPatient = false;

        public get patienten(): number[] {
            return this.selected.map(({ patnr }) => patnr as number);
        }

        public reset(): void {
            this.selected = [];
        }

        public onClickPatient(patnr: number): void {
            if (this.openingPatient || this.patientData?.patnr === patnr) {
                return;
            }

            this.openingPatient = true;

            this.loadPatient({ patnr })
                .then(() => this.openingPatient = false);
        }

        public onClickRechnung(): void {
            this.setZahlendePatienten(this.selected);
            this.setDialogRechnung(true);
        }

        public onClickFinish(): void {
            const warteliste = this.patienten;
            const en = warteliste.length === 1 ? '' : 'en';

            confirmSwal('Warteliste', `Patient${en} abschließen?`, 'Fertig', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.finishWarteliste({ warteliste });

                        if (this.patientData?.patnr && warteliste.some((patnr) => patnr === this.patientData?.patnr)) {
                            this.closePatient();
                        }
                    }

                    this.reset();
                });
        }

        public onClickDelete(): void {
            const warteliste = this.patienten;
            const en = warteliste.length === 1 ? '' : 'en';

            confirmSwal('Warteliste', `Patient${en} von Warteliste löschen?`, 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteWarteliste({ warteliste });

                        if (this.patientData?.patnr && warteliste.some((patnr) => patnr === this.patientData?.patnr)) {
                            this.closePatient();
                        }
                    }

                    this.reset();
                });
        }

        public onClickAusblenden(items:any) {
            _.forEach(items, (item: WartelisteItem) => {
                item.status = 'Ausgeblendet';
            });

            this.updateWartelisteItems({wartelisteitems: items, einblenden: false});
        }

        public onClickEinblenden() {
            _.forEach(this.warteliste, (item: WartelisteItem) => {
                if (item.status === 'Ausgeblendet') {
                    item.status = 'Kassa';
                }
            });
            this.updateWartelisteItems({wartelisteitems: null, einblenden: true});
        }

        get filteredwarteliste() {
            const retval :any[] = [];
            _.forEach(this.warteliste, (item: WartelisteItem) => {
                if (item.status !== 'Ausgeblendet') {
                    retval.push(item);
                }
            });

            return retval;
        }

        get isThereItemAusgeblendet() {
            var res = false;
            _.forEach(this.warteliste, (item: WartelisteItem) => {
                if (item.status === 'Ausgeblendet') {
                    res = true;
                }
            });

            return res;
        }
    }
